import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { IAIVideoModel } from 'types/aiVideo'
import { ITag } from 'components/TagList/types'
import { getStringifiedQuality } from 'store/features/aiVideo/utils'
import { capitalizeFirstLetter } from 'utils'

const convertModelToTag = (model: IAIVideoModel): ITag => ({
  id: capitalizeFirstLetter(model.id.toString()),
  name: model.name
})

const convertQualityToTag = (quality: number): ITag => ({
  id: `quality-${quality}`,
  name: getStringifiedQuality(quality)
})

export const useAiVideoItemTagsData = () => {
  const models = useSelector(aiVideoSelectors.aiVideoModels)

  const getItemTags = useCallback(
    (quality: number, model: string | null): ITag[] => {
      const tags: (ITag | null)[] = []
      if (model) {
        const modelData = models.find(option => option?.model === model)
        if (modelData) {
          tags.push(convertModelToTag(modelData))
        }
      }
      if (quality > 0) {
        tags.push(convertQualityToTag(quality))
      }

      return tags.filter(tag => tag !== null)
    },
    [models]
  )

  return getItemTags
}
